module.exports = __webpack_public_path__ + "static/media/frames-colls-normal-filled.2bbcebbe.png";